import React from "react";
import { useForm } from "react-hook-form";
import { Form, FormActions, FormDropdown, FormFields, mapToDropdownOption } from "sprint-common-web";

import { useEditAsperaDeliveryInfoForm } from "./useEditAsperaDeliveryInfoForm";

export interface EditDeliveryInfoFormProps {
    onCancel(): void;
    onSubmit(): void;
}

export interface EditAsperaDeliveryInfoFormInputs {
    type: string;
    deliveryEndpointId: string;
}

export const EditAsperaDeliveryInfoForm: React.VFC<EditDeliveryInfoFormProps> = ({
    onSubmit,
    onCancel
}: EditDeliveryInfoFormProps) => {
    const { itemToEdit, deliveryEndpoints, editAsperaDeliveryInfo } = useEditAsperaDeliveryInfoForm();

    const { errors, control, formState, handleSubmit } = useForm<EditAsperaDeliveryInfoFormInputs>({
        defaultValues: {
            deliveryEndpointId: itemToEdit?.deliveryEndpoint?.id ?? ""
        },
        criteriaMode: "all"
    });

    const handleEditDeliveryInfo = async (inputs: EditAsperaDeliveryInfoFormInputs) => {
        await editAsperaDeliveryInfo(inputs);
        onSubmit();
    };

    const handleCancelButtonClick = () => {
        onCancel();
    };

    return (
        <Form onSubmit={handleSubmit(handleEditDeliveryInfo)}>
            <FormFields>
                <FormDropdown
                    options={deliveryEndpoints.map((item) => mapToDropdownOption(item))}
                    label="Delivery endpoint"
                    name="deliveryEndpointId"
                    control={control}
                    errors={errors}
                    rules={{ required: "Select delivery endpoint" }}
                />
            </FormFields>
            <FormActions
                isLoading={formState.isValidating || formState.isSubmitting}
                onCancel={handleCancelButtonClick}
            />
        </Form>
    );
};
